export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  if (!config.public.scripts?.clarity?.id) {
    return;
  }
  useScriptClarity();
});
